import { render } from "./qnaRead.vue?vue&type=template&id=fdcb4ef6&scoped=true"
import script from "./qnaRead.vue?vue&type=script&lang=js"
export * from "./qnaRead.vue?vue&type=script&lang=js"

import "@/styles/striNew.css?vue&type=style&index=0&lang=css"
import "./qnaRead.vue?vue&type=style&index=1&id=fdcb4ef6&scoped=true&lang=css"
import "@/styles/mobile.css?vue&type=style&index=2&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-partnerpage-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdcb4ef6"]])

export default __exports__